import { DeepResearchClar, IDeepResearchClarConfig, IDeepResearchClarItem } from './deep-research-clar';
import { decodeFromUrlComponent } from '@src/utils/codec';
import { GlobalEventType, IDeepResearchClarFormAction, IDeepResearchClarification, MessageEventDTO } from '@src/types';
import { EventBus } from '@/utils/event-bus';

export default {
  tag: 'deepresearchclar',
  format: '<deepresearchclar />',
  sourcePipeline: (source: string) => {
    const matches = source.match(/:::deepresearchclar{payload="([^"]+)"}\n\n:::\n\n/) || [];
    if (matches.length > 0) {
      return `<deepresearchclar payload="${matches[1]}" />`;
    }
    return source;
  },
  componentFn: ({ payload }: { payload: string }) => {
    const message = decodeFromUrlComponent(payload) as MessageEventDTO;
    const config = message?.ref_detail?.intent_clarification as IDeepResearchClarification;
    if (!config) {
      return null;
    }
    const onSubmit = async (formItems: IDeepResearchClarItem[], action: IDeepResearchClarFormAction) => {
      const newMessage = {
        ...message,
        ref_detail: {
          intent_clarification: {
            ...config,
            formItems,
            actions: [action],
          },
        },
      }
      EventBus.emit(GlobalEventType.DEEP_RESEARCH_CLAR_SUBMIT, JSON.stringify(newMessage), formItems.map(item => item.label + ': ' + item.value).join('\n'));
    };
    return <DeepResearchClar config={{...config, action: config.actions[0]}} onSubmit={onSubmit} />;
  },
};
